module.exports = __webpack_public_path__ + "static/img/视频回放.f3cf8c7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/视频回放.svg
// module id = aUQm
// module chunks = 1